import { render } from "./JournalPanel.vue?vue&type=template&id=742ccaa8&scoped=true"
import script from "./JournalPanel.vue?vue&type=script&lang=js"
export * from "./JournalPanel.vue?vue&type=script&lang=js"

import "./JournalPanel.vue?vue&type=style&index=0&id=742ccaa8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742ccaa8"]])

export default __exports__